import { Button, SxProps } from '@mui/material';
import React from 'react';
import { ClockLoader } from 'react-spinners';

type Props = {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  style?: React.CSSProperties;
  children: string;
  fullSize?: boolean;
  size?: 'medium' | 'large' | 'small' | undefined;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  fontColor?: string;
  color?: string;
  sx?: SxProps;
  disabled?: boolean;
  loading?: boolean;
  variant?: 'text' | 'outlined' | 'contained';
  preserveCase?: boolean;
  autoFocus?: boolean;
};

const EdButton: React.FC<Props> = (props) => {
  const {
    style,
    children,
    fullSize,
    size,
    startIcon,
    endIcon,
    color,
    fontColor,
    disabled,
    loading,
    variant,
    preserveCase,
    autoFocus,
    ...other
  } = props;

  let newStyles = fullSize ? { width: '100%', height: '100%', ...style } : { ...style };

  if (color) {
    newStyles = { ...newStyles, backgroundColor: color };
  }
  if (fontColor) {
    newStyles = { ...newStyles, color: fontColor };
  }
  return (
    <Button
      disabled={disabled}
      style={{
        ...newStyles,
        pointerEvents: loading ? 'none' : 'auto', // Evita cliques enquanto está carregando
        textTransform: preserveCase ? 'none' : 'uppercase'
      }}
      variant={variant ? variant : 'contained'}
      color="primary"
      endIcon={endIcon}
      size={size}
      autoFocus={autoFocus}
      startIcon={loading ? <ClockLoader size={20} color={fontColor ?? 'white'} /> : startIcon}
      {...other}
    >
      {children}
    </Button>
  );
};

export default EdButton;
